import { render, staticRenderFns } from "./giveawayPopup.vue?vue&type=template&id=52846016&"
import script from "./giveawayPopup.vue?vue&type=script&lang=js&"
export * from "./giveawayPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports